import React from 'react';
import styles from './AudiosUI.module.css';

const AudiosUI = ({
  title,
  image,
  onClick,
  imageFit = 'cover',
  square = true,
}) => {
  return (
    <div className={styles.card} onClick={onClick}>
      <div className={styles.imageContainer} style={{ aspectRatio: square ? '1' : undefined }}>
        <img
          src={image}
          alt={title}
          className={styles.image}
          style={{ objectFit: imageFit }}
          loading="lazy"
        />
      </div>
      <div className={styles.audioInfo}>
        <h3 className={styles.audioTitle}>{title}</h3>
      </div>
    </div>
  );
};

export default AudiosUI;